import { NavWrapper } from '@seller-hermes/pages/wrappers';
import { Loader2 } from 'lucide-react';
import { memo, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// import SuggestDialog from '../features/ui/Suggest/suggest.dialog';

export const LoggedMobilePageLayout = memo(() => {
  return (
    <NavWrapper>
      <Suspense
        fallback={
          <div className="flex h-full w-full items-center justify-center">
            <Loader2 className="text-muted-foreground h-8 w-8 animate-spin" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
      {/* <SuggestDialog /> */}
    </NavWrapper>
  );
});
